/**
 * Post type filters
 *
 * @package Embark
 * @since   1.0.0
 */

const getUrlParameter = (name) => {
	/* eslint-disable */
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
	const results = regex.exec(window.location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	/* eslint-enable */
};

// Define our comment reply funciton.
const initPostTypeFilters = () => {
	const loc = window.location;
	const url = loc.origin + loc.pathname;
	const currentURL = loc.href;
	const sourceFilter = document.querySelector('#source-select');

	if (sourceFilter) {
		sourceFilter.onchange = (e) => {
			if (e.target.value) {
				if (currentURL.indexOf('search') > -1) {
					const search = getUrlParameter('search');
					window.location.href = `${url}?search=${search}&source=${e.target.value}`;
				} else {
					window.location.href = `${url}?source=${e.target.value}`;
				}
			} else {
				window.location.href = url;
			}
		};
	}

	// Search
	const searchForm = document.querySelector('.filters .search-form');

	if (searchForm) {
		searchForm.addEventListener('submit', (e) => {
			const searchField = document.querySelector('.filters .search-field');
			const source = getUrlParameter('source');

			if (source) {
				e.preventDefault();
				window.location.href = `${url}?search=${searchField.value}&source=${source}`;
			}
		});
	}
};


document.addEventListener('DOMContentLoaded', initPostTypeFilters);
